<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-top:100px; padding-bottom:50px;">About the Author</h1>
<p style="text-indent:0">Gordon S. Dickson was born near Inverness, Scotland, but left at an early age when his family returned to Northern Ireland.</p>
<br/>
<p style="text-indent:0">He was educated at secondary and grammar schools, and scraped through English ‘O’ level, as essay writing was not his strength.</p>
<br/>
<p style="text-indent:0">He was employed in the civil service for several years but is now retired and has only recently taken up writing novels. <em>An Impossible Quest: A Bartonshire Tale 2</em> is his latest novel.</p>
<br/>
<p style="text-indent:0">He enjoys reading several genres of books but mainly historical and detective novels, and gardening.</p>
<br/>
<p style="text-indent:0">Other books by this author are:</p>
<p style="text-indent:0"><em>Verdict Unknown</em></p>
<p style="text-indent:0"><em>The Sheriff of River Bend</em></p>
<p style="text-indent:0"><em>Des Pond, Special Agent</em></p>
<p style="text-indent:0"><em>The Wartime Adventures of Harry Harris</em></p>
<p style="text-indent:0"><em>– Bartonshire Tale 1</em></p>
<p style="text-indent:0"><em>Verdict Unknown, the Sequel</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?216bb420